import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Fabricante } from 'src/app/admihair/api/dto/fabricante';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FabricanteService } from 'src/app/admihair/service/fabricante.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';

@Component({
  selector: 'app-fabricante-inserir',
  templateUrl: './fabricante-inserir.component.html',
  styleUrls: ['./fabricante-inserir.component.scss']
})
export class FabricanteInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  fabricanteEncontrado: boolean = false;

  constructor(private fabricanteService: FabricanteService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_FABRICANTE');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
  }

  salvar() {
    this.progressoRequisicao = true;
    const fabricante: Fabricante = this.form?.form.value;
    fabricante.descricao = FormatacaoUtil.removerCaracteresEspeciais(fabricante.descricao);
    fabricante.empresa = this.empresaSelecionada;
    if (!fabricante.cnpj) {
      fabricante.cnpj = '';
    }
    this.fabricanteService.salvar(fabricante).subscribe({
      next: () => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
        this.progressoRequisicao = false;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }

    });
  }

  buscarFabricante() {
    const cnpj = this.form?.value.cnpj;
    if (cnpj && cnpj.length === 14) {
      this.fabricanteService.buscarPorEmpresaECnpj(this.empresaSelecionada?.id, cnpj).subscribe({
        next: () => {
          this.fabricanteEncontrado = true;
        },
        error: (err: any) => {
          this.fabricanteEncontrado = false;
        }
      });
    } else {
      console.log('cnpj inválido ou vazio')
      this.fabricanteEncontrado = false;
    }
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }
  limparFormulario() {
    this.form?.reset();
  }

  ocultarMsg() {
    this.messagemVisivel = false;
  }

}
